import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { LiquidityPoolIcon } from '@root/shared/ui-kit'

type Props = {}

export const TableLiquidityPoolCell: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <Label>{t('pool.liquidity-pool')}</Label>
      <Icon size={14} />
    </Root>
  )
}

const Root = styled.div<{ $color?: string }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  align-items: center;
  justify-content: start;
  gap: 4px;
`

const Label = styled.div`
  text-transform: uppercase;
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
`

const Icon = styled(LiquidityPoolIcon)`
  color: var(--cyan-9);
`
